module.exports = __webpack_public_path__ + "img/arm-03-front.47ddc06e.png";